$(document).on('click','#form_newsletter_modal', function () {
		console.log('modal');
});